import gallerData from "../Assets/galleryData";
export const WorkTab = [
  // [
  {
    id: 1,
    category: "flatbed",
    imageUr1: gallerData.BIKE1,
  },
  {
    id: 2,
    category: "flatbed",
    imageUr1: gallerData.FLATBED1,
  },
  {
    id: 3,
    category: "flatbed",
    imageUr1: gallerData.FLATBED2,
  },
  {
    id: 4,
    category: "flatbed",
    imageUr1: gallerData.FLATBED3,
  },
  {
    id: 5,
    category: "flatbed",
    imageUr1: gallerData.FLATBED4,
  },
  {
    id: 6,
    category: "flatbed",
    imageUr1: gallerData.Flatbed5,
  },
  {
    id: 7,
    category: "flatbed",
    imageUr1: gallerData.Flatbed7,
  },
  {
    id: 8,
    category: "flatbed",
    imageUr1: gallerData.Flatbed8,
  },
  {
    id: 9,
    category: "flatbed",
    imageUr1: gallerData.Flatbed9,
  },
  {
    id: 10,
    category: "flatbed",
    imageUr1: gallerData.Flatbed10,
  },
  {
    id: 11,
    category: "flatbed",
    imageUr1: gallerData.Flatbed11,
  },
  {
    id: 12,
    category: "flatbed",
    imageUr1: gallerData.Flatbed12,
  },
  {
    id: 13,
    category: "flatbed",
    imageUr1: gallerData.Flatbed13,
  },
  {
    id: 14,
    category: "flatbed",
    imageUr1: gallerData.Flatbed14,
  },
  {
    id: 15,
    category: "flatbed",
    imageUr1: gallerData.Flatbed15,
  },
  {
    id: 16,
    category: "flatbed",
    imageUr1: gallerData.Flatbed16,
  },
  {
    id: 17,
    category: "flatbed",
    imageUr1: gallerData.Flatebed17,
  },
  {
    id: 18,
    category: "flatbed",
    imageUr1: gallerData.Flatbed19,
  },
  {
    id: 19,
    category: "flatbed",
    imageUr1: gallerData.Flatbed20,
  },
  {
    id: 20,
    category: "flatbed",
    imageUr1: gallerData.Flatbed21,
  },
  {
    id: 21,
    category: "flatbed",
    imageUr1: gallerData.Flatbed23,
  },
  {
    id: 22,
    category: "flatbed",
    imageUr1: gallerData.Flatbed24,
  },
  {
    id: 23,
    category: "flatbed",
    imageUr1: gallerData.Flatbed25,
  },
  {
    id: 24,
    category: "flatbed",
    imageUr1: gallerData.Flatbed26,
  },
  {
    id: 25,
    category: "flatbed",
    imageUr1: gallerData.Flatbed27,
  },
  {
    id: 26,
    category: "flatbed",
    imageUr1: gallerData.Flatbed28,
  },
  {
    id: 27,
    category: "flatbed",
    imageUr1: gallerData.Flatbed27,
  },
  {
    id: 28,
    category: "flatbed",
    imageUr1: gallerData.Flatbed28,
  },
  {
    id: 22,
    category: "flatbed",
    imageUr1: gallerData.Flatbed29,
  },
  {
    id: 22,
    category: "flatbed",
    imageUr1: gallerData.Flatbed30,
  },

  // *******************************bike CAR**********************************
  {
    id: 1,
    category: "bike",
    imageUr1: gallerData.BIKE1,
  },

  {
    id: 2,
    category: "bike",
    imageUr1: gallerData.BIKE3,
  },
  {
    id: 3,
    category: "bike",
    imageUr1: gallerData.BIKE2,
  },
  {
    id: 4,
    category: "bike",
    imageUr1: gallerData.BIKE4,
  },
  {
    id: 5,
    category: "bike",
    imageUr1: gallerData.BIKE5,
  },
  {
    id: 6,
    category: "bike",
    imageUr1: gallerData.BIKE6,
  },
  {
    id: 7,
    category: "bike",
    imageUr1: gallerData.BIKE7,
  },
  {
    id: 8,
    category: "bike",
    imageUr1: gallerData.BIKE8,
  },
  {
    id: 9,
    category: "bike",
    imageUr1: gallerData.BIKE9,
  },
  {
    id: 10,
    category: "bike",
    imageUr1: gallerData.BIKE10,
  },
  // *******************************Heavy vehichle**********************************
  {
    id: 1,
    category: "heavy",
    imageUr1: gallerData.HEAVY,
  },
  {
    id: 2,
    category: "heavy",
    imageUr1: gallerData.heavy3,
  },

  // *******************************CLOSED CAR**********************************
  {
    id: 1,
    category: "closed",
    imageUr1: gallerData.CLOSED1,
  },
  {
    id: 2,
    category: "closed",
    imageUr1: gallerData.CLOSED2,
  },
  {
    id: 3,
    category: "closed",
    imageUr1: gallerData.CLOSED3,
  },
  {
    id: 4,
    category: "closed",
    imageUr1: gallerData.CLOSED4,
  },
  {
    id: 5,
    category: "closed",
    imageUr1: gallerData.CLOSED5,
  },
  {
    id: 6,
    category: "closed",
    imageUr1: gallerData.CLOSED6,
  },
  {
    id: 7,
    category: "closed",
    imageUr1: gallerData.CLOSED7,
  },
  // *******************************UNEDER CAR**********************************
  {
    id: 1,
    category: "under",
    imageUr1: gallerData.UNDER1,
  },
  {
    id: 2,
    category: "under",
    imageUr1: gallerData.UNDER2,
  },
  {
    id: 3,
    category: "under",
    imageUr1: gallerData.UNDER3,
  },
  {
    id: 4,
    category: "under",
    imageUr1: gallerData.UNDER4,
  },
  {
    id: 5,
    category: "under",
    imageUr1: gallerData.UNDER5,
  },
  {
    id: 6,
    category: "under",
    imageUr1: gallerData.UNDER6,
  },
  {
    id: 7,
    category: "under",
    imageUr1: gallerData.UNDER7,
  },
  {
    id: 8,
    category: "under",
    imageUr1: gallerData.UNDER8,
  },
  {
    id: 9,
    category: "under",
    imageUr1: gallerData.UNDER9,
  },
  {
    id: 10,
    category: "under",
    imageUr1: gallerData.UNDER10,
  },
  {
    id: 11,
    category: "under",
    imageUr1: gallerData.UNDER11,
  },
  {
    id: 12,
    category: "under",
    imageUr1: gallerData.UNDER12,
  },
  {
    id: 13,
    category: "under",
    imageUr1: gallerData.UNDER13,
  },
  {
    id: 14,
    category: "under",
    imageUr1: gallerData.UNDER14,
  },
  {
    id: 15,
    category: "under",
    imageUr1: gallerData.UNDER15,
  },
  {
    id: 16,
    category: "under",
    imageUr1: gallerData.UNDER16,
  },
  //////////////////// Video ///////////////////////
  {
    id: 1,

    category: "video",
    imageUr1: gallerData.VIDEO1,
    link: "https://www.youtube.com/watch?app=desktop&v=kfA4iEjNK_Q",
  },
  {
    id: 2,

    category: "video",
    imageUr1: gallerData.VIDEO2,
    link: "https://www.youtube.com/watch?app=desktop&v=kfA4iEjNK_Q",
  },
  {
    id: 3,

    category: "video",
    imageUr1: gallerData.VIDEO3,
    link: "https://www.youtube.com/watch?app=desktop&v=kfA4iEjNK_Q",
  },
  {
    id: 3,

    category: "video",
    imageUr1: gallerData.VIDEO4,
    link: "https://www.youtube.com/watch?app=desktop&v=kfA4iEjNK_Q",
  },

];
